// Saga for VAT Period Export
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  VAT_INVOICE_LIST,
  VAT_INVOICE_ITEM_LIST,
  VAT_PURCHASE_LIST,
  VAT_PURCHASE_ITEM_LIST,
} from "./actionType";

import {
  vatInvoiceListSuccess,
  vatInvoiceListFail,
  vatInvoiceItemListSuccess,
  vatInvoiceItemListFail,
  vatPurchaseListSuccess,
  vatPurchaseListFail,
  vatPurchaseItemListSuccess,
  vatPurchaseItemListFail,
} from "./action";

import {
  getVatInvoiceList,
  getVatInvoiceItemList,
  getVatPurchaseList,
  getVatPurchaseItemList,
} from "../../helpers/fakebackend_helper";

function* vatInvoiceListSaga({ data }) {
  try {
    const response = yield call(getVatInvoiceList, data);
    yield put(vatInvoiceListSuccess(response));
  } catch (error) {
    yield put(vatInvoiceListFail(error));
  }
}

function* watchVatInvoiceList() {
  yield takeEvery(VAT_INVOICE_LIST, vatInvoiceListSaga);
}

function* vatInvoiceItemListSaga({ data }) {
  try {
    const response = yield call(getVatInvoiceItemList, data);
    yield put(vatInvoiceItemListSuccess(response));
  } catch (error) {
    yield put(vatInvoiceItemListFail(error));
  }
}

function* watchVatInvoiceItemList() {
  yield takeEvery(VAT_INVOICE_ITEM_LIST, vatInvoiceItemListSaga);
}

function* vatPurchaseListSaga({ data }) {
  try {
    const response = yield call(getVatPurchaseList, data);
    yield put(vatPurchaseListSuccess(response));
  } catch (error) {
    yield put(vatPurchaseListFail(error));
  }
}

function* watchVatPurchaseList() {
  yield takeEvery(VAT_PURCHASE_LIST, vatPurchaseListSaga);
}

function* vatPurchaseItemListSaga({ data }) {
  try {
    const response = yield call(getVatPurchaseItemList, data);
    yield put(vatPurchaseItemListSuccess(response));
  } catch (error) {
    yield put(vatPurchaseItemListFail(error));
  }
}

function* watchVatPurchaseItemList() {
  yield takeEvery(VAT_PURCHASE_ITEM_LIST, vatPurchaseItemListSaga);
}

export default function* VatPeriodExport() {
  yield all([
    fork(watchVatInvoiceList),
    fork(watchVatInvoiceItemList),
    fork(watchVatPurchaseList),
    fork(watchVatPurchaseItemList),
  ]);
}
